import { closeAction } from 'components/core/task/send_reminder/actions'
import reducer, { SendRemindersState } from 'components/core/task/send_reminder/reducer'
import { SendReminderFormData, SendReminderView } from 'components/core/task/send_reminder/SendReminderView'
import { useAlert } from 'hooks/useAlert'
import { getSendReminderPreview, sendReminder } from 'lib/actions/task'
import { useClientRPC } from 'lib/rpcts'
import { TaskServiceClient } from 'pbts/c1/api/task/v1/task.client'
import { User } from 'pbts/c1/api/user/v1/user'
import { FC, useEffect, useReducer } from 'react'
import { useIntl } from 'react-intl'

export type SendReminderProps = {
    close: () => void
    taskID?: string
}

export const SendReminder: FC<SendReminderProps> = ({ taskID, close }) => {
    const intl = useIntl()
    const taskSvc = useClientRPC<TaskServiceClient>(TaskServiceClient)
    const [state, dispatch] = useReducer(reducer, new SendRemindersState())
    const alert = useAlert()

    useEffect((): void => {
        if (!taskID) return
        getSendReminderPreview(dispatch, taskSvc, taskID)
    }, [taskSvc, taskID])

    useEffect((): void => {
        if (state.open) return
        close()
    }, [state, close])

    useEffect((): void => {
        if (!state.sent) return
        alert(
            intl.formatMessage({
                id: 'components_core_send_reminders_sent_alert',
                defaultMessage: 'Reminder sent.',
            }),
            'success',
        )
        dispatch({ type: closeAction })
    }, [state, alert, intl])

    if (!taskID) return null

    const handleSubmit = (data: SendReminderFormData): void => {
        const copiedUserIDs = data.copiedUsers.map((user: User) => user.id)
        sendReminder(dispatch, taskSvc, taskID, data.notifyManager, data.message, copiedUserIDs)
    }

    const handleClose = (): void => dispatch({ type: closeAction })

    return <SendReminderView
        open={state.open}
        onClose={handleClose}
        hasReceivers={state.hasReceivers}
        canShowManager={state.canShowManager}
        canCCOthers
        onSubmit={handleSubmit}
    />
}
